/**
 * Breadcrumb JSON-LD Schema
 *
 * Provides navigation context for search engines.
 * https://schema.org/BreadcrumbList
 */

const BASE_URL = 'https://linkpool.com'

/**
 * Generate BreadcrumbList schema from path segments
 */
export function createBreadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${BASE_URL}${item.path}`
    }))
  }
}

export const breadcrumbBrand = createBreadcrumbSchema([
  { name: 'Home', path: '/' },
  { name: 'Brand Assets', path: '/brand' }
])

export const breadcrumbBrandVc = createBreadcrumbSchema([
  { name: 'Home', path: '/' },
  { name: 'Brand Assets - LinkPool Ventures', path: '/brand-linkpool-vc' }
])
